import { Component, OnInit, Input, signal } from '@angular/core';
import { MemberQuery, TransactionType } from '@fgb/core';

@Component({
  selector: 'fgb-transaction-history',
  templateUrl: './transaction-history.component.html',
  styleUrls: ['./transaction-history.component.scss'],
})
export class TransactionHistoryComponent implements OnInit {
  constructor(private memberQuery: MemberQuery) { }

  transactionStartDate = signal<Date>(new Date());
  transactionEndDate = signal<Date>(new Date());
  transactionType = signal<TransactionType | null>(null);
  minDate: Date = new Date(2020, 0, 1);

  @Input() jetsCash: boolean = false;
  @Input() memberId: string;
  @Input() transactionTypes: TransactionType[];
  @Input() ecashView: boolean;
  @Input() accountView: boolean;

  selectedValues = signal<{ start: Date; end: Date; type: TransactionType } | null>(null);
  isFirstAccess = signal<boolean>(true);

  buttonNames = {
    [TransactionType.ecash]: 'Ecash History',
    [TransactionType.loyalty]: 'Points History',
    [TransactionType.payment]: 'Card History',
  };

  ngOnInit() {
    this.transactionType.set(this.transactionTypes[0]);
    this.memberId = this.memberId || this.memberQuery.getUserContext().memberId;

    // Date picker defaults to last 15 days
    const end = new Date();
    const start = new Date();
    start.setDate(start.getDate() - 15);

    this.transactionEndDate.set(end);
    this.transactionStartDate.set(start);

    this.loadLatestData();
  }

  setTransactionType(type: TransactionType) {
    this.transactionType.set(type);
  }

  search() {
    this.isFirstAccess.set(false);
    const start = new Date(this.transactionStartDate());
    const end = new Date(this.transactionEndDate());

    start.setHours(0, 0, 0, 0);
    end.setHours(23, 59, 59, 999);

    this.selectedValues.set({
      start,
      end,
      type: this.transactionType()!,
    });
  }

  loadLatestData() {
    this.isFirstAccess.set(true);

    const end = new Date();
    const start = new Date(this.minDate);

    start.setHours(0, 0, 0, 0);
    end.setHours(23, 59, 59, 999);

    this.selectedValues.set({
      start,
      end,
      type: this.transactionType()!,
    });
  }
}
